<div class="no-action" *ngIf="notVerify"></div>
<div class="row px-3 pt-2 px-md-2">
  <div class="col-12 col-lg-6 col-xl-6 p-0 pt-3 p-md-3 donut-chart--wrapper">
    <div class="panel panel-default">
      <np-send-referral></np-send-referral>
    </div>
  </div>

  <div class="col-12 col-lg-6 col-xl-6 p-0 pt-3 p-md-3 donut-chart--wrapper">
    <div class="panel panel-default">
      <np-donut-chart [data]='donutChartData'></np-donut-chart>
    </div>
  </div>


  <div class="col-12 col-xl-12 p-0 pt-3 p-md-3 area-chart--wrapper">
    <div class="panel panel-default">
      <np-area-chart [data]="areaChartData" class="d-block area-chart-container"></np-area-chart>
    </div>
  </div>
</div>